export class BaseCanvas {
    constructor(params) {
        this.params = params
        
        this.$canvas = params?.canvas ?? document.body.querySelector('canvas') ?? document.createElement('canvas')
        this.ctx = this.$canvas.getContext('2d')
        this.canvasPixelRatio = 1
    }
    setSize(width, height, updateStyle = false) {
        // console.log(`BaseCanvas::setSize(${width}, ${height})`)
        // this._width = width
        // this._height = height

        this.$canvas.width = width * this.canvasPixelRatio
        this.$canvas.height = height * this.canvasPixelRatio

        if (updateStyle === true) {
            this.$canvas.style.width = `${width}px`
            this.$canvas.style.height = `${height}px`
        }

        this.ctx.scale(this.canvasPixelRatio, this.canvasPixelRatio)
    }
}